import { z } from 'zod';
const parseNumericParam = (val) => {
    if (val === null || val === undefined || val === '')
        return null;
    if (typeof val === 'string') {
        const processed = val.replace(',', '.');
        const parsed = parseFloat(processed);
        return isNaN(parsed) ? val : parsed;
    }
    return val;
};
const numericParam = (min, max) => z.preprocess(parseNumericParam, z.union([
    z.number().min(min, `Min ${min}`).max(max, `Max ${max}`),
    z.null()
]));
export const upsertVoiceSchema = z.object({
    id: z.number().optional(),
    name: z.string().min(1, 'Name is required'),
    provider: z.enum(['elevenlabs', 'rime']),
    ext_id: z.string().nullable(),
    provider_config: z.object({
        speed: numericParam(0.5, 1.3),
        style: numericParam(0, 1),
        stability: numericParam(0, 1),
        similarity_boost: numericParam(0, 1),
        use_speaker_boost: z.boolean().nullable(),
    }),
    model: z.string().nullable(),
});
